export default __webpack_public_path__ + "pgnv-assets/522b2105e379fba665399a5ef6273a0b.png";